// extracted by mini-css-extract-plugin
export default {"layout":"aCCx4l","layoutContent":"bCCx4l"};